"use client";

import React, { useEffect, useMemo, useState } from "react";

import dynamic from "next/dynamic";
import { useParams } from "next/navigation";

import { GlobalPathParams } from "~/app/[locale]/types";
import { HeaderProvider } from "~/context/header/provider";
import { importComponentByName } from "~/helpers/import-component-by-name";

import { OffscreenNavigationProps } from "../global-navigation/components/desktop-global-navigation/offscreen-navigation/types";

import { HeaderDesktop } from "./components/header-desktop/component";
import { HeaderMobile } from "./components/header-mobile/component";
import { convertHeaderToProps } from "./helpers/convert-header-to-props";
import { DesktopHeaderWrapper } from "./styled";
import { ExtendedHeaderProps, ConvertedHeaderProps } from "./types";

const OffscreenNavigation = dynamic<OffscreenNavigationProps>(async () =>
  importComponentByName(
    import(
      "../global-navigation/components/desktop-global-navigation/offscreen-navigation/component"
    ),
    "OffscreenNavigation",
  ),
);

export const Header: React.FC<ExtendedHeaderProps> = (data) => {
  const { locale } = useParams<GlobalPathParams>();

  const { searchPanel } = data;
  const props: ConvertedHeaderProps = useMemo(
    () => convertHeaderToProps(data),
    [data],
  );
  const [isInfoBannerClose, setIsInfoBannerClose] = useState(false);
  const handleBannerClose = () => {
    setIsInfoBannerClose(true);
  };

  useEffect(() => {
    setIsInfoBannerClose(false);
  }, [locale]);

  return (
    <HeaderProvider>
      <DesktopHeaderWrapper id="desktopHeader" role="banner">
        <HeaderDesktop
          {...props}
          onInfoBannerClose={handleBannerClose}
          isInfoBannerClose={isInfoBannerClose}
          searchPanel={searchPanel}
        />
      </DesktopHeaderWrapper>
      <HeaderMobile
        {...props}
        onInfoBannerClose={handleBannerClose}
        isInfoBannerClose={isInfoBannerClose}
        searchPanel={searchPanel}
      />
      <OffscreenNavigation
        navigation={props.navigation}
        viewAllLabel={props?.translations?.viewAll}
      />
    </HeaderProvider>
  );
};
